import type { CreateTruckInput } from '@chukua/common';
import { Form, InputNumber, Switch } from 'antd';

const CAPABILITY_FIELDS: { name: keyof CreateTruckInput; label: string }[] = [
  { name: 'hasGenset', label: 'Genset' },
  { name: 'isBonded', label: 'Bonded' },
  { name: 'isHazardousCertified', label: 'Hazardous-certified' },
  { name: 'isCrossBorderEquipped', label: 'Cross-border equipped' },
];

/** Capacity, tank size and the job-fit capability flags — shared by create and edit (CreateTruckDrawer, TruckDetailsForm). */
export function TruckCapabilityFields() {
  return (
    <>
      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="capacityTonnes" label="Capacity (t)" rules={[{ required: true, message: 'Enter a capacity' }]}>
          <InputNumber className="w-full" min={0.01} step={0.5} />
        </Form.Item>
        <Form.Item name="tankCapacityLitres" label="Tank (L)" rules={[{ required: true, message: 'Enter tank capacity' }]}>
          <InputNumber className="w-full" min={1} step={10} />
        </Form.Item>
      </div>
      <div className="mb-2 grid grid-cols-2 gap-x-4 gap-y-2">
        {CAPABILITY_FIELDS.map(({ name, label }) => (
          <Form.Item key={name} name={name} label={label} valuePropName="checked" className="mb-0">
            <Switch />
          </Form.Item>
        ))}
      </div>
    </>
  );
}
